import { render } from "./DashboardDataTableAptV6Old.vue?vue&type=template&id=24b7a266"
import script from "./DashboardDataTableAptV6Old.vue?vue&type=script&lang=js"
export * from "./DashboardDataTableAptV6Old.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__